export class ClaimElevationRequest {
    public ChallengeKey : string;
}